
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import ApiError from '@/error/apiError'

export default defineComponent({
  name: 'ProfileApiError',
  components: { AButton },
  data() {
    return {
      active: true,
      MAX_BLOCKED_USERS: 'max_blocked_users',
    }
  },
  props: {
    apiError: {
      type: ApiError,
      required: true,
    },
  },
})
